// /expenses DataGrid 컬럼 정의.
// flex 전면 제거 → width + minWidth 고정. 넘치는 컬럼은 그리드 내부 가로 스크롤로 처리된다.

import type { GridColDef } from "@mui/x-data-grid";
import { IExpense } from "../interfaces";

// 비용성(숫자 문자열) 컬럼 공통 스펙
const amountColumn = (field: string, headerName: string): GridColDef<IExpense> => ({
  field,
  headerName,
  type: "string",
  width: 88,
  minWidth: 80,
  align: "right",
  headerAlign: "right",
});

export const expensesColumns: GridColDef<IExpense>[] = [
  {
    field: "id",
    headerName: "ID",
    type: "number",
    width: 84,
    minWidth: 72,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "agentName",
    headerName: "현장요원이름",
    width: 120,
    minWidth: 100,
  },
  { field: "agentCode", headerName: "현장요원코드", type: "string", width: 132, minWidth: 110 },
  { field: "hasCar", headerName: "자차여부", type: "string", width: 96, minWidth: 80, align: "center", headerAlign: "center" },
  amountColumn("post", "우편료"),
  amountColumn("gas", "연료비"),
  amountColumn("parking", "주차비"),
  amountColumn("toll", "톨비"),
  { ...amountColumn("etc", "기타"), width: 108, minWidth: 90 },
  { field: "date", headerName: "방문일", type: "string", width: 116, minWidth: 108, align: "center", headerAlign: "center" },
  { field: "comment", headerName: "비고", type: "string", width: 200, minWidth: 150 },
  { field: "updatedAt", headerName: "수정일", type: "string", width: 150, minWidth: 120 },
];
